import { message } from "antd";
import { useNavigate } from "react-router-dom";
import type { MembershipProduct, SpaceProfile } from "../SpaceType";
import { membershipCanEnterRetailPurchase } from "../membershipPurchaseUtils";
import { membershipNoRetailPurchaseHint } from "../spacePageUtils";
import { h5NavigateTo } from "../../utils/miniProgramEnv";
import { guardDouyinMiniProgramSubscribe } from "../../utils/douyinMiniProgramSubscribeGuard";
import { resolveProductPosterUrl } from "./spaceProductUtils";
import "./SpaceProductStyle.css";

/** 未订阅产品：海报 + 订阅引导（H5 简化版） */
export function SpaceModuleSubscribeGate(props: {
  spaceId: string;
  row: MembershipProduct;
  isLoggedIn: boolean;
  onLoginRequest: () => void;
  onSubscribeScroll?: () => void;
  spaceProfile: SpaceProfile | null;
}) {
  const { spaceId, row, isLoggedIn, onLoginRequest } = props;
  const navigate = useNavigate();
  const posterSrc = resolveProductPosterUrl(row);
  const upgradeEligible =
    row.upgradeEligible === true && !!row.upgradeSourceSpaceProductId?.trim();
  const isFollowerFree = row.pricingMode?.trim().toLowerCase() === "follower_free";

  const onSubscribeClick = () => {
    if (!isLoggedIn) {
      onLoginRequest();
      return;
    }
    if (!membershipCanEnterRetailPurchase(row) && !upgradeEligible) {
      message.info(membershipNoRetailPurchaseHint(row));
      return;
    }
    guardDouyinMiniProgramSubscribe(() => {
      h5NavigateTo(navigate, `/space/${spaceId}/subscribe/${encodeURIComponent(row.spaceProductId)}`);
    });
  };

  return (
    <div className="space-product-gate" aria-label="会员开通引导">
      <div className="space-product-gate__poster-wrap">
        {posterSrc ? (
          <img src={posterSrc} alt="" className="space-product-gate__poster-img" />
        ) : (
          <div className="space-product-gate__poster-fallback">
            <p className="space-product-gate__poster-name">{row.displayName}</p>
            {row.description?.trim() ? (
              <p className="space-product-gate__poster-desc">{row.description.trim()}</p>
            ) : null}
          </div>
        )}
        <div className="space-product-gate__shade" aria-hidden />
        <div className="space-product-gate__cta">
          <p className="space-product-gate__hint">
            {isFollowerFree ? "关注本空间即可免费使用" : "开通后即可使用完整服务"}
          </p>
          <button type="button" className="space-product-gate__btn" onClick={onSubscribeClick}>
            {isFollowerFree ? "去关注" : upgradeEligible ? "升级" : "去订阅"}
          </button>
        </div>
      </div>
    </div>
  );
}
